module.exports = __webpack_public_path__ + "img/amazonMusic.88462b0c.png";